import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
import SET_SELLER from './types';
export default _defineProperty({}, SET_SELLER, function (state, payload) {
  var currentState = state;
  currentState.seller = payload;
});